<template>
  <div class="list">
    <div  class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        服务消息
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <div class="center_list_head_rig" @click="dialogFormVisible1 = true">添加消息</div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="id" width="80" label="编号" align="center"></el-table-column>
        <el-table-column prop="mobile" label="用户账号" align="center"></el-table-column>
        <el-table-column prop="title" label="消息标题" align="center"></el-table-column>
        <el-table-column
          prop="content"
          show-overflow-tooltip
          width="300"
          label="消息内容"
          align="center"
        ></el-table-column>
        <el-table-column prop="create_date" width="180" label="时间" align="center"></el-table-column>

        <!-- @change="status($event,scope.row.id)" -->
        <el-table-column label="是否推送" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="rgb(19, 206, 102)"
              inactive-color="#dcdfe6"
              active-value="1"
              inactive-value="0"
              @change="swith($event,scope.row.id)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="dialogFormVisible2 = true,redact(scope.row.id)" class="button1">编辑</button>
            <button @click="del(scope.row.id)" class="button1">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="8"></el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加消息 -->
    <el-dialog title="添加消息" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="消息内容:">
          <textarea name id cols="47" rows="10" v-model="content"></textarea>
        </el-form-item>
        <el-form-item label="用户账号:">
          <el-input style="width:356px" v-model="mobile" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="消息标题:">
          <el-input style="width:356px" v-model="title" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑消息 -->
    <el-dialog title="编辑消息" :visible.sync="dialogFormVisible2" width="33%">
      <el-form>
        <el-form-item label="消息内容:">
          <textarea name v-model="red_content" id cols="47" rows="10"></textarea>
        </el-form-item>
        <el-form-item label="消息标题:">
          <el-input style="width:356px" v-model="red_title" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitRedact()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      id: "",
      content: "",
      title: "",
      mobile: "",
      red_content: "",
      red_title: "",
      red_status: "",
      msg: ""
    };
  },
  created() {
    this.$store.state.leftTitle = "服务消息";
    this.$store.state.topActiveId = 1;
    this.geting();
  },

  methods: {
    del(id) {
      this.$confirm("删除后不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delete_serve_message", {
              params: {
                username: this.username,
                token: this.token,
                id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.geting();
              }else if(res.data.status == "error"){
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    swith(v, id) {
      //开关

      this.axios
        .get(this.serve + "/admin/status_serve_message", {
          params: {
            username: this.username,
            token: this.token,
            id
          }
        })
        .then(res => {
          if (v == "1") {
            this.$notify({
              title: "成功",
              message: "推送成功",
              type: "success"
            });
          }
          if (v == "0") {
            this.$notify({
              title: "成功",
              message: "禁止成功",
              type: "warning"
            });
          }
          //   if(res.data.status == 'success'){

          //   }
        });
    },
    redact(id) {
      //点击编辑弹窗

      const _this = this;
      this.axios
        .get(this.serve + "/admin/edit_serve_message", {
          params: {
            username: this.username,
            token: this.token,
            id
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            _this.red_content = json.content;
            _this.red_title = json.title;
            _this.red_status = json.status;
            _this.id = json.id;
          }else if(res.data.status == "error"){
            this.$message.error(res.data.msg);
          }
        });
    },
    submitRedact() {
      //编辑确定提交
      const _this = this;
      this.axios
        .get(this.serve + "/admin/submit_serve_message", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id,
            title: this.red_title,
            content: this.red_content
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.dialogFormVisible2 = false;
            _this.geting();
            _this.open1();
          } else if (res.data.status == "error") {
            _this.geting();
            _this.open4();
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error(this.msg);
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },
    open1() {
      this.$message({
        //成功时 返回的状态
        message: "编辑成功",
        type: "success"
      });
    },
    submitAdd() {
      //添加弹窗提交

      if (this.content == "") {
        this.$message.error("请输入消息内容");
        return;
      }

      if (this.title == "") {
        this.$message.error("请输入消息标题");
        return;
      }
      if (this.mobile == "") {
        this.$message.error("请输入用户账号");
        return;
      }

      const _this = this;

      this.axios
        .get(this.serve + "/admin/add_serve_message", {
          params: {
            username: this.username,
            token: this.token,
            content: this.content,
            title: this.title,
            mobile: this.mobile
          }
        })
        .then(res => {
          _this.msg = res.data.msg;
          if (res.data.status == "success") {
            _this.dialogFormVisible1 = false;
            _this.open();
            _this.geting();
          } else if (res.data.status == "error") {
            _this.open4();
          }
        });
    },
    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据

      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/serve_message_list", {
          params: {
            token: this.token,
            username: this.username,
            page
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            that.tableData = [];
            var json = res.data.data;
            if (json) {
              that.total = res.data.data.total;
              that.page = res.data.data.page;
              for (var key in json.results) {
                var time = json.results[key].create_date;
                var timeNew = new Date(parseInt(time) * 1000)
                  .toLocaleString()
                  .replace(/:\d{1,2}$/, " ");
                json.results[key].create_date = timeNew;
                that.tableData.push(json.results[key]);
              }
            }
          }else if(res.data.status == 'error' && res.data.code == '403')
          {
            this.role = false
          }
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>